import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gold text-navy py-2 px-4 text-center font-dmsans font-bold text-sm shadow-md" data-id="element-173">
      🔥 Precio de lanzamiento — Sube pronto — Aprovechá ahora
    </div>;
}